import { render, staticRenderFns } from "./SettingsNotificationMailingEmailFrom.vue?vue&type=template&id=d57f4978&"
import script from "./SettingsNotificationMailingEmailFrom.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationMailingEmailFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports